import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import Logo from '../../../assets/images/logo.png'
import UserService from '../../../services/users';


const FormLogin = () => {
    const [email, setEmail] = useState("")
    const [senha, setSenha] = useState("")
    const [error, setError] = useState(false);
    const [direct, setDirect] = useState(false);

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const user = await UserService.login(
                {
                    email: email,
                    senha: senha
                }
            )
            await redireciona()
        } catch (error) {
            setError(error)
        }
    }

    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        switch (user) {
            case "Administrador":
                setDirect("/restrito")
                break;
            case "Legislador":
                await setDirect("/restrito/leis")
                break;
            case "Licitador":
                await setDirect("/restrito/licitacao")
                break;
            case "Controle Interno":
                await setDirect("/restrito/controle")
                break;
            case "Saude":
                await setDirect("/restrito/saude")
                break;
            case "Educação":
                await setDirect("/restrito/educacao")
                break;
            case "RH":
                await setDirect("/restrito/rh")
                break;
            case "Obras":
                await setDirect("/restrito/obras")
                break;
            case "Diario":
                await setDirect("/restrito/diario")
                break;
            case "Ouvidor":
                await setDirect("/restrito/ouvidoria")
                break;
        }
    }


    const redireciona = async () => {
        await getNivel();
    }

    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    }
    return (
        <Fragment>
            <Card className='box-login'>
                <Card.Img variant="top" src={Logo} className="logo-login" />
                <Card.Body>
                    <Form onSubmit={HandleSubmit}>
                        <Form.Group className="mb-3" controlId="email">
                            <FloatingLabel
                                label="E-mail"
                                className="mb-3"
                            >
                                <Form.Control
                                    required
                                    type="email"
                                    name="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </FloatingLabel>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="senha">
                            <FloatingLabel
                                label="Senha"
                                className="mb-3"
                            >

                                <Form.Control
                                    required
                                    type="password"
                                    name="senha"
                                    value={senha}
                                    onChange={e => setSenha(e.target.value)} />

                            </FloatingLabel>
                        </Form.Group>
                        {error && <Alert color="danger">Email ou senha inválidos!</Alert>}
                        <Button variant="outline-light" type="submit">
                            Entrar
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Fragment>
    )
}

export default FormLogin;